'use client';

import React, { ReactNode, useCallback, useEffect, useState } from 'react';

import { Portal } from '@/components/ui/Portal/Portal';

import * as S from './Toast.styles';

export const useToast = (children: ReactNode, offsetY = 0) => {
  const [mounted, setMounted] = useState(false);
  const [animated, setAnimated] = useState(false);
  const [onClose, setOnClose] = useState<(() => void) | null>(null);

  const removeToast = useCallback(() => {
    setAnimated(false);

    setTimeout(() => {
      setMounted(false);
      onClose?.();
    }, 1000);
  }, [onClose]);

  const openToast = useCallback((callback?: () => void) => {
    setOnClose(() => callback ?? null);
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setTimeout(() => {
        setAnimated(true);
      }, 200);
    }
  }, [mounted]);

  useEffect(() => {
    if (animated) {
      setTimeout(() => removeToast(), 2000);
    }
  }, [animated]);

  const toast = mounted ? (
    <Portal>
      <S.Container $show={animated} $offsetY={offsetY}>
        {children}
      </S.Container>
    </Portal>
  ) : null;

  return {
    toast,
    openToast
  };
};
